export default __webpack_public_path__ + "static/media/26.0f51825b.png";